import React, { useState, useEffect, memo } from "react";
import { useLocation } from "react-router-dom";
import {
  SubMenuItem,
  MenuLink,
  ScrollContainer,
  Layout,
  Content,
} from "./MainMenuBar.style";

import FW from "../../../../../config/word.json";

// メニュー定義
export const homeBar = [
  {
    title: FW.F_W_SYS_HOME,
    path: "/home",
    icon: <img src="/images/icons/home_active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/home.svg" alt="" />,
  },
];

export const logOutBar = [
  {
    title: FW.F_W_SYS_LOGOUT,
    path: "/",
    icon: <img src="/images/icons/log-out-active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/log-out.svg" alt="" />,
  },
];

export const approvalGroupBar = [
  {
    title: FW.F_W_HOME_ApprovalList,
    path: "/approvallist",
    icon: (
      <span role="img" aria-label="承認待ち" style={{ fontSize: "20px" }}>
        ⏳
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="承認待ち" style={{ fontSize: "20px" }}>
        ⏳
      </span>
    ),
  },
  {
    title: FW.F_W_HOME_ApprovaledList,
    path: "/approvaledlist",
    icon: (
      <span role="img" aria-label="承認済み" style={{ fontSize: "20px" }}>
        ✅
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="承認済み" style={{ fontSize: "20px" }}>
        ✅
      </span>
    ),
  },
  {
    title: FW.F_W_HOME_RejectList,
    path: "/rejectedlist",
    icon: (
      <span role="img" aria-label="否認" style={{ fontSize: "20px" }}>
        ❌
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="否認" style={{ fontSize: "20px" }}>
        ❌
      </span>
    ),
  },
];
// 基本ボタン
export const menuGroupBar = [
  {
    title: FW.F_W_SYS_HOME,
    path: "/home",
    icon: (
      <img
        src="/images/icons/home_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/home.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
  {
    title: FW.F_W_SYS_LOGOUT,
    path: "/",
    icon: (
      <img
        src="/images/icons/log-out-active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/log-out.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
];

export const fansGroupBar = [
  {
    title: FW.F_W_HOME_JOIN,
    path: "/joinInfo",
    icon: (
      <img
        src="/images/icons/user.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/user_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
  {
    title: FW.F_W_HOME_FAN,
    path: "/fans",
    icon: (
      <img
        src="/images/icons/fans.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/fans_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
  {
    title: FW.F_W_HOME_FANCOUNT,
    path: "/countFans",
    icon: (
      <img
        src="/images/icons/count.svg"
        alt=""
        color="#cccccc"
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/count_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
];

// ゲスト用
export const fansGroupBarForGuest_8 = [
  {
    title: FW.F_W_HOME_JOIN,
    path: "/joinInfoForGuest",
    icon: (
      <img
        src="/images/icons/user.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/user_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
];

// 広告
export const adGroupBar = [
  {
    title: "統計",
    path: "/adDisplayInfo",
    icon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
  },
  {
    title: "広告一覧",
    path: "/adList",
    icon: (
      <span role="img" aria-label="広告一覧" style={{ fontSize: "20px" }}>
        📋
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="広告一覧" style={{ fontSize: "20px" }}>
        📋
      </span>
    ),
  },
];

// バナー
export const bannerGroupBar = [
  {
    title: "大バナー",
    path: "/bannerManage",
    icon: (
      <span role="img" aria-label="大バナー" style={{ fontSize: "20px" }}>
        🖼️
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="大バナー" style={{ fontSize: "20px" }}>
        大
      </span>
    ),
  },
  {
    title: "小バナー",
    path: "/smallBannerManage",
    icon: (
      <span role="img" aria-label="小バナー" style={{ fontSize: "20px" }}>
        🧑‍🤝‍🧑
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="小バナー" style={{ fontSize: "20px" }}>
        小
      </span>
    ),
  },
];

// データ移行
export const sysGroupBar = [
  {
    title: "データ移行",
    path: "/dataIko",
    icon: (
      <span role="img" aria-label="データ移行" style={{ fontSize: "20px" }}>
        🔄
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="データ移行" style={{ fontSize: "20px" }}>
        🔄
      </span>
    ),
  },
];

// ゲスト用
export const adGroupBar_7 = [
  {
    title: "統計",
    path: "/dashboard",
    icon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
  },
];

// 子リンクコンポーネント
const CustomMenuLink = ({
  title,
  to,
  icon,
  clickedIcon,
  activePath,
  onClick,
}) => {
  const isActive = activePath === to;
  const url = useLocation().pathname;
  const onClickMenuItem = (toPage) => () => {
    if (toPage === "/") {
      sessionStorage.clear();
    }
  };
  const active = url.includes(to) && to !== "/" ? "active" : "";

  return (
    <SubMenuItem>
      <MenuLink
        to={to}
        onClick={onClickMenuItem(to)}
        style={{
          color: isActive ? "white" : "#cccccc", // フォント色だけ切替
        }}
      >
        <span
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
          aria-hidden="true"
        >
          {active ? icon : clickedIcon}
          <span>{title}</span>
        </span>
      </MenuLink>
    </SubMenuItem>
  );
};

function MenuBar() {
  const location = useLocation();

  // 一つだけ開くメニューのキーをstateで管理
  const [openKey, setOpenKey] = useState(() => {
    const saved = sessionStorage.getItem("openKey");
    return saved || null;
  });

  // クリック中の子メニューのpathをstateで管理（初期値は現在のURLパス）
  const [activePath, setActivePath] = useState(location.pathname);

  // URL変化があればactivePathも更新
  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  // openKey を sessionStorage に保存
  useEffect(() => {
    if (openKey) {
      sessionStorage.setItem("openKey", openKey);
    } else {
      sessionStorage.removeItem("openKey");
    }
  }, [openKey]);

  // メニューの開閉切替
  const toggleOpen = (key) => {
    setOpenKey((prev) => (prev === key ? null : key));
  };

  return (
    <Layout>
      <Content>
        <ScrollContainer>
          {/* 基本 */}
          <SubMenuItem>
            <div
              onClick={() => toggleOpen("base")}
              style={{
                cursor: "pointer",
                color: openKey === "base" ? "white" : "#cccccc",
                padding: "8px",
                borderRadius: "4px",
                marginBottom: "4px",
              }}
            >
              ≡基本
            </div>
            {openKey === "base" &&
              menuGroupBar.map((item) => (
                <CustomMenuLink
                  key={item.title}
                  title={item.title}
                  to={item.path}
                  icon={item.icon}
                  clickedIcon={item.clickedIcon}
                  activePath={activePath}
                  onClick={() => setActivePath(item.path)}
                />
              ))}
          </SubMenuItem>
          {sessionStorage.getItem("userFlg") === "9" && (
            <>
              {/* 承認フロー */}
              <SubMenuItem>
                <div
                  onClick={() => toggleOpen("approval")}
                  style={{
                    cursor: "pointer",
                    color: openKey === "approval" ? "white" : "#cccccc",
                    padding: "8px",
                    borderRadius: "4px",
                    marginBottom: "4px",
                  }}
                >
                  ✅承認フロー
                </div>
                {openKey === "approval" &&
                  sessionStorage.getItem("userFlg") === "9" &&
                  approvalGroupBar.map((item) => (
                    <CustomMenuLink
                      key={item.title}
                      title={item.title}
                      to={item.path}
                      icon={item.icon}
                      clickedIcon={item.clickedIcon}
                      activePath={activePath}
                      onClick={() => setActivePath(item.path)}
                    />
                  ))}
              </SubMenuItem>

              {/* ファン */}
              <SubMenuItem>
                <div
                  onClick={() => toggleOpen("fans")}
                  style={{
                    cursor: "pointer",
                    color: openKey === "fans" ? "white" : "#cccccc",
                    padding: "8px",
                    borderRadius: "4px",
                    marginBottom: "4px",
                  }}
                >
                  ❤️ファン
                </div>
                {openKey === "fans" &&
                  sessionStorage.getItem("userFlg") === "9" &&
                  fansGroupBar.map((item) => (
                    <CustomMenuLink
                      key={item.title}
                      title={item.title}
                      to={item.path}
                      icon={item.icon}
                      clickedIcon={item.clickedIcon}
                      activePath={activePath}
                      onClick={() => setActivePath(item.path)}
                    />
                  ))}
              </SubMenuItem>

              {/* 広告 */}
              <SubMenuItem>
                <div
                  onClick={() => toggleOpen("ad")}
                  style={{
                    cursor: "pointer",
                    color: openKey === "ad" ? "white" : "#cccccc",
                    padding: "8px",
                    borderRadius: "4px",
                    marginBottom: "4px",
                  }}
                >
                  📢広告
                </div>
                {openKey === "ad" &&
                  sessionStorage.getItem("userFlg") === "9" &&
                  adGroupBar.map((item) => (
                    <CustomMenuLink
                      key={item.title}
                      title={item.title}
                      to={item.path}
                      icon={item.icon}
                      clickedIcon={item.clickedIcon}
                      activePath={activePath}
                      onClick={() => setActivePath(item.path)}
                    />
                  ))}
              </SubMenuItem>

              {/* バナー管理 */}
              <SubMenuItem>
                <div
                  onClick={() => toggleOpen("banner")}
                  style={{
                    cursor: "pointer",
                    color: openKey === "banner" ? "white" : "#cccccc",
                    padding: "8px",
                    borderRadius: "4px",
                    marginBottom: "4px",
                  }}
                >
                  🖼️バナー
                </div>
{openKey === "banner" &&
                    sessionStorage.getItem("userFlg") === "9" &&
                    bannerGroupBar.map((item) => (
                      <CustomMenuLink
                        key={item.title}
                        title={item.title}
                        to={item.path}
                        icon={item.icon}
                        clickedIcon={item.clickedIcon}
                        activePath={activePath}
                        onClick={() => setActivePath(item.path)}
                      />
                    ))}
              </SubMenuItem>

              {/* システム */}
              <SubMenuItem>
                <div
                  onClick={() => toggleOpen("sys")}
                  style={{
                    cursor: "pointer",
                    color: openKey === "sys" ? "white" : "#cccccc",
                    padding: "8px",
                    borderRadius: "4px",
                    marginBottom: "4px",
                  }}
                >
                  ⚙️システム
                </div>
                {openKey === "sys" &&
                  sessionStorage.getItem("userFlg") === "9" &&
                  sysGroupBar.map((item) => (
                    <CustomMenuLink
                      key={item.title}
                      title={item.title}
                      to={item.path}
                      icon={item.icon}
                      clickedIcon={item.clickedIcon}
                      activePath={activePath}
                      onClick={() => setActivePath(item.path)}
                    />
                  ))}
              </SubMenuItem>
            </>
          )}

          {sessionStorage.getItem("userFlg") === "8" && (
            <>
              {/* ゲストファン */}
              <SubMenuItem>
                <div
                  onClick={() => toggleOpen("fans")}
                  style={{
                    cursor: "pointer",
                    color: openKey === "fans" ? "white" : "#cccccc",
                    padding: "8px",
                    borderRadius: "4px",
                    marginBottom: "4px",
                  }}
                >
                  ❤️ファン
                </div>
                {openKey === "fans" &&
                  sessionStorage.getItem("userFlg") === "8" &&
                  fansGroupBarForGuest_8.map((item) => (
                    <CustomMenuLink
                      key={item.title}
                      title={item.title}
                      to={item.path}
                      icon={item.icon}
                      clickedIcon={item.clickedIcon}
                      activePath={activePath}
                      onClick={() => setActivePath(item.path)}
                    />
                  ))}
              </SubMenuItem>
              {/* 空白 */}
              <SubMenuItem>
                <div
                  onClick={() => ""}
                  style={{
                    cursor: "pointer",
                    color: openKey === "fans" ? "white" : "#cccccc",
                    padding: "8px",
                    borderRadius: "4px",
                    marginBottom: "4px",
                  }}
                ></div>
              </SubMenuItem>
            </>
          )}

          {sessionStorage.getItem("userFlg") === "7" && (
            <>
              {/* ゲストファン */}
              <SubMenuItem>
                <div
                  onClick={() => toggleOpen("fans")}
                  style={{
                    cursor: "pointer",
                    color: openKey === "fans" ? "white" : "#cccccc",
                    padding: "8px",
                    borderRadius: "4px",
                    marginBottom: "4px",
                  }}
                >
                  📢広告
                </div>
                {openKey === "fans" &&
                  sessionStorage.getItem("userFlg") === "7" &&
                  adGroupBar_7.map((item) => (
                    <CustomMenuLink
                      key={item.title}
                      title={item.title}
                      to={item.path}
                      icon={item.icon}
                      clickedIcon={item.clickedIcon}
                      activePath={activePath}
                      onClick={() => setActivePath(item.path)}
                    />
                  ))}
              </SubMenuItem>
              {/* 空白 */}
              <SubMenuItem>
                <div
                  onClick={() => ""}
                  style={{
                    cursor: "pointer",
                    color: openKey === "fans" ? "white" : "#cccccc",
                    padding: "8px",
                    borderRadius: "4px",
                    marginBottom: "4px",
                  }}
                ></div>
              </SubMenuItem>
            </>
          )}
        </ScrollContainer>
      </Content>
    </Layout>
  );
}

export default memo(MenuBar);
